<div *ngIf="isOpen" (click)="onClose()"
    class="fixed inset-0 z-[70] w-full h-full flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">
    <div (click)="$event.stopPropagation()"
        class="relative bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] flex flex-col overflow-hidden animate-slide-up">
        <!-- Header -->
        <div class="flex items-center justify-between px-7 py-5 bg-white border-b border-slate-100 shrink-0">
            <div class="flex items-center gap-4">
                <div
                    class="w-10 h-10 rounded-[14px] bg-gradient-to-br from-primary to-primary-hover flex items-center justify-center shadow-lg shadow-primary/30">
                    <i class="pi pi-pencil text-white text-base"></i>
                </div>
                <h3 class="text-lg font-black text-slate-800 tracking-tight leading-none">
                    {{ 'modal_edit_health_plan_procedure_title' | translate }}
                </h3>
            </div>
            <button type="button" (click)="onClose()"
                class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-300 hover:text-slate-600 hover:bg-slate-100 transition-all">
                <i class="pi pi-times text-sm"></i>
            </button>
        </div>

        <!-- Body -->
        <div class="p-7 overflow-y-auto flex-1 space-y-6 no-scrollbar">
            <form [formGroup]="form" class="space-y-6">
                <div class="grid grid-cols-2 gap-6">
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_family' | translate }} <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="family"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('family')?.invalid && form.get('family')?.touched}">
                    </div>
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_subfamily' | translate }} <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="subfamily"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('subfamily')?.invalid && form.get('subfamily')?.touched}">
                    </div>
                </div>

                <div class="grid grid-cols-2 gap-6">
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_code' | translate }}</label>
                        <input type="text" formControlName="internal_code"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm">
                    </div>
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_value' | translate }} <span class="text-red-500">*</span></label>
                        <input type="number" step="0.01" formControlName="base_price"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('base_price')?.invalid && form.get('base_price')?.touched}">
                    </div>
                </div>

                <div class="grid grid-cols-2 gap-6">
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_group' | translate }}</label>
                        <input type="text" formControlName="group"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm">
                    </div>
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_subgroup' | translate }}</label>
                        <input type="text" formControlName="subgroup"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm">
                    </div>
                </div>

                <div>
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                        'field_description' | translate }} <span class="text-red-500">*</span></label>
                    <textarea rows="2" formControlName="description"
                        class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm resize-none"
                        [ngClass]="{'border-red-500': form.get('description')?.invalid && form.get('description')?.touched}"></textarea>
                </div>

                <label class="flex items-center gap-3 cursor-pointer w-fit">
                    <input type="checkbox" formControlName="active" class="w-4 h-4 rounded accent-primary">
                    <span class="text-xs font-bold text-slate-600 uppercase tracking-widest">{{ 'field_active' | translate }}</span>
                </label>
            </form>
        </div>

        <!-- Footer -->
        <div class="px-7 py-4 border-t border-slate-100 bg-white flex items-center justify-end gap-3 shrink-0">
            <app-button [label]="'button_cancel' | translate" variant="ghost" (onClick)="onClose()"
                styleClass="!text-[10px] !font-bold !uppercase !tracking-widest !px-6 !py-2">
            </app-button>
            <app-button [label]="'button_save' | translate" [loading]="loading" [disabled]="form.invalid"
                (onClick)="onSubmit()"
                styleClass="!text-[10px] !font-black !uppercase !tracking-widest !px-10 !py-2.5 !rounded-xl !shadow-lg !shadow-primary/20">
            </app-button>
        </div>
    </div>
</div>
